module.exports = __webpack_public_path__ + "static/img/icon-prev-circle.888fce86.png";